import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { BsBroadcast } from 'react-icons/bs';
import { FaUser } from 'react-icons/fa';
import '../../assets/styles/admin_pannel/AdminHeader.css';
import { useNavigate } from "react-router-dom";

const AdminHeader = () => {
    const navigate = useNavigate(); 

  const handleBroadcastMessage = (e) => {
    e.preventDefault(); 
    navigate("/broadcastMessage");
  };

    return (
        <Navbar className="sticky-top navbar">
            <Container
               
                className="d-flex justify-content-between align-items-center pt-2 header-container"
            >
                <Nav className="d-flex align-items-center icon-container">
                    <button onClick={handleBroadcastMessage} className="button">
                        <BsBroadcast className="button-icon" />
                        Broadcast Messages
                    </button>
                    <div className="avatar">
                        <FaUser className="person-icon" />
                    </div>
                </Nav>
            </Container>
        </Navbar>
    );
};

export default AdminHeader;